import { Component, Input, OnInit } from '@angular/core';
import { report, ReportBarCodeType, reportDataField, ReportDataTypes, reportField, reportObject, ReportObjectType, reportSection, ReportSectionTypes, reportSummationField, reportSystemField, ReportSystemFieldTypes, reportTextField, Report_Alignment, Report_Border_Style, Report_Page_Sizes } from '../../models/reports/report';
import { basereportprocess } from '../../models/reports/types/basereportprocess';
import { Iceutility } from '../../services/iceutility';
import { IcePoint, IceRect } from '../icemultimedia/IceMultimediaStroke';
import { IcecontrolSettings } from '../models/icesettings';

@Component({
  selector: 'icereport',
  templateUrl: './icereport.component.html',
  styleUrls: ['./icereport.component.css']
})
export class IcereportComponent implements OnInit {
  @Input() id: string = "";
  @Input() canvasid: string = "reportcanvas" + Iceutility.guid(true);
  @Input() ctrl: IcecontrolSettings = null;

  updateCurrentY: boolean = false;
  longTextCount: number = 0;
  bottomBorderCount: number = 0;

  constructor() {
  }

  ngOnInit() {
    if (this.ctrl != null) {
      let frmCtrl = this.ctrl.getFormControl();
      if (frmCtrl == null) return;

      let rptProcess: basereportprocess = frmCtrl.value;
      if (rptProcess) {
        let rptTemplate = rptProcess.onProcessReport();
        setTimeout(() => {
          debugger;
          const reportCanvas: HTMLCanvasElement = document.getElementById(this.canvasid) as HTMLCanvasElement;
          this.onDraw(rptProcess, rptTemplate, reportCanvas);
        });
      }
    }
  }

  //////////////////////////
  /// Preview and Printing Operations

  private isItTimeForNewPage(rptProcess: basereportprocess, rptTemplate: report, currentY: number): boolean {
    let sysdata = rptProcess.sysdata;
    let rcMargins: IceRect = rptTemplate.getMargins();
    let bottomPix: number = basereportprocess.inch2Pix(rcMargins.bottom, sysdata.pixelsPerInch, sysdata.scale);
    let currentYPix: number = basereportprocess.inch2Pix(currentY, sysdata.pixelsPerInch, sysdata.scale);
    if (currentYPix + bottomPix >= sysdata.pageLimitY)
      return true;

    return false;
  }

  getDocumentSize(paperType: Report_Page_Sizes): IcePoint {
    let ret: IcePoint = new IcePoint();
    if (paperType == Report_Page_Sizes.ps8_5_by_11) {// more sizes are coming
      ret.x = 8.5;
      ret.y = 11.0;
    }
    return ret;
  }

  private complete(reportProcess: basereportprocess, rptTemplate: report, sortfield: number, prevval: any, curval: any): boolean {
    if (sortfield < 0)
      return false;

    return false == this.compareReportFieldData(reportProcess, rptTemplate, sortfield, prevval, curval);
  }

  private continue(reportProcess: basereportprocess, rptTemplate: report, sortfield: number, prevval: any, curval: any): boolean {
    if (sortfield < 0)
      return false;

    return this.compareReportFieldData(reportProcess, rptTemplate, sortfield, prevval, curval);
  }

  private compareReportFieldData(reportProcess: basereportprocess, rptTemplate: report, fieldIndex: number, fieldData1: any, fieldData2: any): boolean {
    if (fieldData1 == null || fieldData2 == null) return false;

    let tC: string = reportProcess.outputColumns[fieldIndex];
    let fld: reportDataField = rptTemplate.getReportDataField(tC);
    if (fld) {
      switch (fld.getDataType()) {
        case ReportDataTypes.dtNumber:
          {
            if (Iceutility.toLong(fieldData1) == Iceutility.toLong(fieldData2))
              return true;

            break;
          }
        case ReportDataTypes.dtBoolean:
          {
            if (Iceutility.toBoolean(fieldData1) == Iceutility.toBoolean(fieldData2))
              return true;

            break;
          }
        case ReportDataTypes.dtDouble:
          {
            if (Iceutility.toDouble(fieldData1) == Iceutility.toDouble(fieldData2))
              return true;

            break;
          }
        case ReportDataTypes.dtText:
          {
            let f1: string = fieldData1;
            let f2: string = fieldData2;
            if (f1.toLowerCase() == f2.toLowerCase())
              return true;

            break;
          }
        case ReportDataTypes.dtDateTime:
          {
            if (fieldData1 == fieldData2)
              return true;

            break;
          }
      }
    }
    return false;
  }

  private getTextWidth(ctx, text: string, font: string): TextMetrics {
    // re-use canvas object for better performance
    let save = ctx.font;
    ctx.font = font;
    ctx.font = save;
    return ctx.measureText(text);
  }

  getAlignmentOffset(ctx: CanvasRenderingContext2D, align: Report_Alignment, startrect: IceRect, text: string, font: string, fontSz: number, offset: number): IcePoint {
    let size: TextMetrics = this.getTextWidth(ctx, text, font);
    let left = startrect.left;
    let top = startrect.top + (fontSz / 2);
    switch (align) {
      case Report_Alignment.alignLeft:
        left = startrect.left + offset;
        break;
      case Report_Alignment.alignRight:
        left = startrect.right - size.width;
        break;
      case Report_Alignment.alignCenter:
        left = startrect.left + (startrect.right - startrect.left - size.width) / 2;
        break;
      case Report_Alignment.alignTop:
        top = startrect.top + 1 + offset;
        break;
      case Report_Alignment.alignBottom:
        top = startrect.bottom - (fontSz / 2) - 1 + offset;
        break;
      case Report_Alignment.alignMiddle:
        top = startrect.top + ((startrect.bottom - startrect.top - (fontSz / 2)) / 2) + offset;
        break;
      default:
        if (size.width >= startrect.right - startrect.left)
          left = startrect.left + offset;
        else
          left = startrect.left + offset;
        top = startrect.top + 1 + offset;
        break;
    }

    return new IcePoint(left, top);
  }

  onDraw(reportProcess: basereportprocess, rptTemplate: report, reportCanvas: HTMLCanvasElement): void {
    if (reportProcess == null || rptTemplate == null || reportCanvas == null) return;

    // On Prepare
    let ctx: CanvasRenderingContext2D = reportCanvas.getContext("2d");
    let records = reportProcess.outputRecords;
    let sysdata = reportProcess.sysdata;
    let rcMargins: IceRect = rptTemplate.getMargins();
    let first_rec = null;

    /////
    let pages = 1;
    let recordsPerPage = 0;
    reportProcess.c_lnUnRealizedPixelPerInch = 72;

    sysdata.currentPageStarting = 0.0;
    sysdata.currentPageNumber = 1;

    // To do research how to make ppi and scale work
    let docSize = this.getDocumentSize(rptTemplate.getPaperSize());
    docSize.x = docSize.x - (rcMargins.left + rcMargins.right);
    docSize.y = docSize.y - (rcMargins.top + rcMargins.bottom);

    let width = screen.width, height = screen.height;
    let sqroot = (width * width) + +(height * height);
    let ppi = ((Math.sqrt(sqroot) / docSize.y) + (Math.sqrt(sqroot) / docSize.x)) / 2;
    ppi = reportProcess.c_lnUnRealizedPixelPerInch;
    sysdata.pixelsPerInch = ppi;
    sysdata.scale = window.devicePixelRatio * 2/*multiplied by two*/;
    sysdata.pageMax = 1;
    sysdata.currentRecordNumber = 1;
    sysdata.recordsPerPage = 0;
    sysdata.dateTime = Iceutility.GetLocalDate();

    sysdata.pageLimitY = basereportprocess.inch2Pix(11.0 /*this.GetDocumentHeight()*/, sysdata.pixelsPerInch, sysdata.scale);
    sysdata.currentPageY = 0;
    sysdata.pageFooterPrinted = false;

    sysdata.sort1Field = -1;
    sysdata.sort2Field = -1;
    sysdata.sort3Field = -1;

    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader1);
    if (section && section.getShow()) {
      sysdata.sort1Field = reportProcess.getReportFieldIndex(section.getSortFullName());
      section = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2);
      if (section && section.getShow()) {
        sysdata.sort2Field = reportProcess.getReportFieldIndex(section.getSortFullName());
        section = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3);
        if (section && section.getShow()) {
          sysdata.sort3Field = reportProcess.getReportFieldIndex(section.getSortFullName());
        }
      }
    }

    let pageHeader = 0.0, pageFooter = 0.25, reportHeader = 0.5, reportFooter = 0.5, recordHeight = 0.5;

    if (records.length > 0) {
      let topOfPage = rcMargins.top / reportProcess.c_lnUnRealizedPixelPerInch;

      first_rec = records[0];

      // print report header
      /*
      reportHeader = CalcReportHeader(& dc, 0.0, pfirst_rec);
      pageHeader = CalcPageHeader(& dc, 0.0, pfirst_rec);
      pageFooter = CalcPageFooter(& dc, 0.0, pfirst_rec);
      pageFooter = pageFooter - this.GetDocumentHeight();
      reportFooter = CalcReportFooter(& dc, 0.0, pfirst_rec);

      recordHeight = CalcSortHeader1(& dc, recordHeight, pfirst_rec);
      recordHeight = CalcSortHeader2(& dc, recordHeight, pfirst_rec);
      recordHeight = CalcSortHeader3(& dc, recordHeight, pfirst_rec);

      recordHeight = CalcDetail(& dc, recordHeight, pfirst_rec);

      recordHeight = CalcSortFooter3(& dc, recordHeight, pfirst_rec);
      recordHeight = CalcSortFooter2(& dc, recordHeight, pfirst_rec);
      recordHeight = CalcSortFooter1(& dc, recordHeight, pfirst_rec);
      */

      let nOneDetail = basereportprocess.inch2Pix(recordHeight, sysdata.pixelsPerInch, reportProcess.c_dblUnRealizedScale);
      let nOnePageHdrFtr = basereportprocess.inch2Pix(pageHeader + pageFooter, sysdata.pixelsPerInch, reportProcess.c_dblUnRealizedScale);

      recordsPerPage = 1;

      let startingY: number = recordHeight;
      for (let i = 0; i < records.length; i++) {
        startingY += recordHeight;
        if (this.isItTimeForNewPage(reportProcess, rptTemplate, topOfPage + pageHeader + pageFooter + startingY))
          break;

        recordsPerPage++;
      }

      // PIX Page Calc
      let totalDetails = records.length * nOneDetail;
      let totalReportHdrFtr = basereportprocess.inch2Pix(reportHeader + reportFooter, sysdata.pixelsPerInch, reportProcess.c_dblUnRealizedScale);
      let pagesBasedOnPIX = (totalDetails + totalReportHdrFtr) / sysdata.pageLimitY;
      let remainderBasedOnPIX = (totalDetails + totalReportHdrFtr) % sysdata.pageLimitY;
      if (remainderBasedOnPIX > 0) // if there is a remainder add one more page
        pagesBasedOnPIX += 1;

      // Record Page Calc
      pages = records.length / recordsPerPage;
      let nremainder = records.length % recordsPerPage;
      if (nremainder > 0) // if there is a remainder add one more page
        pages += 1;

      pages = Math.max(pagesBasedOnPIX, pages);
      sysdata.recordsPerPage = recordsPerPage;
    }

    sysdata.pageMax = pages;
    /////

    let startingY: number = rcMargins.top;

    sysdata.pageLimitY = basereportprocess.inch2Pix(docSize.y, sysdata.pixelsPerInch, sysdata.scale);

    reportCanvas.width = basereportprocess.inch2Pix(docSize.x, sysdata.pixelsPerInch, sysdata.scale).toString();
    reportCanvas.height = basereportprocess.inch2Pix(docSize.y, sysdata.pixelsPerInch, sysdata.scale).toString();

    if (sysdata.currentRecordNumber - 1 >= records.length)
      sysdata.currentRecordNumber = records.length - 1; // go back to the last record

    let printstack: reportSection[] = [];
    let secmap = {};
    secmap[ReportSectionTypes.secSortFooter1] = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter1);
    secmap[ReportSectionTypes.secSortFooter2] = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2);
    secmap[ReportSectionTypes.secSortFooter3] = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3);
    secmap[ReportSectionTypes.secDetail] = reportProcess.getSectionByType(ReportSectionTypes.secDetail);
    secmap[ReportSectionTypes.secSortHeader3] = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3);
    secmap[ReportSectionTypes.secSortHeader2] = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2);
    secmap[ReportSectionTypes.secSortHeader1] = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader1);

    for (let secName in Object.keys(secmap)) {
      let repSec: reportSection = <reportSection>secmap[secName];
      if (repSec) repSec.setPrinted(false);
    }

    if (sysdata.currentPageNumber == 1) {
      sysdata.currentRecordNumber = 1;

      first_rec = records[sysdata.currentRecordNumber - 1];

      // print report header
      startingY = this.printReportHeader(reportProcess, rptTemplate, ctx, startingY, first_rec);

      startingY = this.printPageHeader(reportProcess, rptTemplate, ctx, startingY, first_rec);
      reportProcess
      sysdata.sort1Field = reportProcess.getReportFieldIndex(reportProcess.getSectionByName(basereportprocess.getSectionNameByType(ReportSectionTypes.secSortHeader1)).getSortFullName());
      sysdata.sort2Field = reportProcess.getReportFieldIndex(reportProcess.getSectionByName(basereportprocess.getSectionNameByType(ReportSectionTypes.secSortHeader2)).getSortFullName());
      sysdata.sort3Field = reportProcess.getReportFieldIndex(reportProcess.getSectionByName(basereportprocess.getSectionNameByType(ReportSectionTypes.secSortHeader3)).getSortFullName());

      if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
        return;
      }
    }

    first_rec = null;
    let rec = first_rec = records[sysdata.currentRecordNumber - 1];
    if (rec == null) return;

    let prev_rec = rec;
    if (sysdata.currentRecordNumber > 1)
      prev_rec = records[sysdata.currentRecordNumber - 2]; // correct to prev record

    if (sysdata.currentPageNumber > 1) // do page header for pages above 1
    {
      // print page header
      startingY = this.printPageHeader(reportProcess, rptTemplate, ctx, startingY, rec);
    }

    let thisPageRecordCount = 0;
    do {
      if (sysdata.sort1Field >= 0 && this.complete(reportProcess, rptTemplate, sysdata.sort1Field, prev_rec[sysdata.sort1Field], rec[sysdata.sort1Field])) {
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter1));
        for (let secName in Object.keys(secmap)) {
          let repSec: reportSection = <reportSection>secmap[secName];
          if (repSec) repSec.setPrinted(false);
        }
      }

      if (sysdata.sort2Field >= 0 && this.complete(reportProcess, rptTemplate, sysdata.sort2Field, prev_rec[sysdata.sort2Field], rec[sysdata.sort2Field])) {
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2));

        // To do check object before use
        reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2).setPrinted(false);
        reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3).setPrinted(false);

        reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2).setPrinted(false);
        reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3).setPrinted(false);
      }

      if (sysdata.sort3Field >= 0 && this.complete(reportProcess, rptTemplate, sysdata.sort3Field, prev_rec[sysdata.sort3Field], rec[sysdata.sort3Field])) {
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3));

        reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3).setPrinted(false);
        reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3).setPrinted(false);
      }

      // Print remaining sections
      while (printstack.length != 0) {
        let sec: reportSection = printstack.pop();
        if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
          break;
        }

        if (sec.isPrinted() == false) {
          startingY = this.printSection(reportProcess, rptTemplate, ctx, sec, startingY, prev_rec);
          sec.setPrinted(true);
        }
      }

      let secDtl = reportProcess.getSectionByType(ReportSectionTypes.secDetail);
      printstack.push(secDtl); secDtl.setPrinted(false);

      if (sysdata.sort3Field >= 0)
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3));

      if (sysdata.sort2Field >= 0)
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2));

      if (sysdata.sort1Field >= 0)
        printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortHeader1));

      // Print the queue
      while (printstack.length != 0) {
        let sec: reportSection = printstack.pop();
        if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
          break;
        }

        if (sec.isPrinted() == false) {
          startingY = this.printSection(reportProcess, rptTemplate, ctx, sec, startingY, rec);
          sec.setPrinted(true);
        }
      }

      if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
        break;
      }

      sysdata.currentRecordNumber++;

      // We will use this in the future to control the number of records per page by the user
      thisPageRecordCount++;
      if (thisPageRecordCount >= sysdata.recordsPerPage)
        break;

      prev_rec = rec;
    } while ((sysdata.currentRecordNumber - 1) < records.length
      && (rec = records[sysdata.currentRecordNumber - 1]) != null);

    // Print Remaining sections
    if (sysdata.sort1Field >= 0 && (
      this.complete(reportProcess, rptTemplate, sysdata.sort1Field, prev_rec[sysdata.sort1Field], rec[sysdata.sort1Field])
      || sysdata.currentPageNumber == sysdata.pageMax)) {
      printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter1));
      for (let secName in Object.keys(secmap)) {
        let repSec: reportSection = <reportSection>secmap[secName];
        if (repSec) repSec.setPrinted(false);
      }
    }

    if (sysdata.sort2Field >= 0 && (
      this.complete(reportProcess, rptTemplate, sysdata.sort2Field, prev_rec[sysdata.sort2Field], rec[sysdata.sort2Field])
      || sysdata.currentPageNumber == sysdata.pageMax)) {
      printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2));

      reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2).setPrinted(false);
      reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3).setPrinted(false);

      reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2).setPrinted(false);
      reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3).setPrinted(false);
    }

    if (sysdata.sort3Field >= 0 && (
      this.complete(reportProcess, rptTemplate, sysdata.sort3Field, prev_rec[sysdata.sort3Field], rec[sysdata.sort3Field])
      || sysdata.currentPageNumber == sysdata.pageMax)) {
      printstack.push(reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3));

      reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3).setPrinted(false);
      reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3).setPrinted(false);
    }

    // Print remaining sections
    while (printstack.length != 0) {
      let sec: reportSection = printstack.pop();
      if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
        break;
      }

      if (sec.isPrinted() == false) {
        startingY = this.printSection(reportProcess, rptTemplate, ctx, sec, startingY, prev_rec);
        sec.setPrinted(true);
      }
    }

    if (sysdata.currentPageNumber == sysdata.pageMax) {
      if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
        return;
      }

      startingY = this.printReportFooter(reportProcess, rptTemplate, ctx, startingY, prev_rec);
      startingY = this.printPageFooter(reportProcess, rptTemplate, ctx, startingY, pageFooter, prev_rec);
    }
    else {
      if (this.isItTimeForNewPage(reportProcess, rptTemplate, startingY)) {
        return;
      }

      startingY = this.printPageFooter(reportProcess, rptTemplate, ctx, startingY, pageFooter, prev_rec);
    }

    // To do
    //for (int isum = 0; isum < this.reportObj.getSumFieldCount(); isum++ )
    //{
    //  CReportSummationField * pSumField = pRW -> GetSumField(isum);
    //  if (pSumField) {
    //    // reset values
    //    pSumField -> SetHeaderValue(COleVariant((double)0.0));
    //    pSumField -> SetDetailValue(COleVariant((double)0.0));
    //    pSumField -> SetFooterValue(COleVariant((double)0.0));

    //    pSumField -> SetHeaderValue(COleVariant((long)0));
    //    pSumField -> SetDetailValue(COleVariant((long)0));
    //    pSumField -> SetFooterValue(COleVariant((long)0));
    //  }
    //}
  }

  doSection(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, section: reportSection, rec: any[]) {
    let currentY = sectionStart;
    let lastCurrentY = currentY;

    if (this.isItTimeForNewPage(reportProcess, rptTemplate, currentY + section.getHeight())) {
      console.log("New Page Needed.");
    }

    for (let y = 0.0; y <= section.getHeight(); y += reportProcess.c_dblDEFAULTCELL_Y) {
      let objs = section.getObjectsByY(y);

      // print section
      for (let i = 0; i < objs.length; i++) {
        let obj: reportObject = objs[i];
        if (obj) {
          switch (obj.getType()) {
            case ReportObjectType.otNone:
              break;
            case ReportObjectType.otObject: {
              let y_Returned = this.doFormatObject(reportProcess, rptTemplate, ctx, currentY + y, obj, true);
              if (this.updateCurrentY) {
                currentY = currentY + reportProcess.c_dblDEFAULTCELL_Y;
              }
              if (y_Returned > lastCurrentY)
                lastCurrentY = y_Returned;
            }
              break;
            case ReportObjectType.otTextField: {
              let fld: reportTextField = <reportTextField>obj;
              let y_Returned = this.doFormat(reportProcess, rptTemplate, ctx, currentY + y, fld, true);
              if (this.updateCurrentY) {
                currentY = currentY + reportProcess.c_dblDEFAULTCELL_Y;
              }
              if (y_Returned > lastCurrentY)
                lastCurrentY = y_Returned;
            }
              break;
            case ReportObjectType.otDataField: {
              if (null != rec) {
                let fld: reportDataField = <reportDataField>obj;
                let iFieldIndex = reportProcess.getReportFieldIndex(fld.getFullName());
                if (iFieldIndex >= 0 && iFieldIndex < rec.length) {
                  fld.setData(rec[iFieldIndex]);
                  //To do: however selection fields and report fields may end up being the same
                  //CReportDataField selectionFld;
                  //if (pRW -> GetSelectionField(pFld -> GetFullName(), selectionFld)) {
                  //  pFld -> SetHandWriting(selectionFld.GetHandWriting());
                  //}

                  let data = rec.filter(r => Iceutility.isdefined(r) && r.length > 100);
                  this.longTextCount = data.length;

                  let y_Returned = this.doFormatData(reportProcess, rptTemplate, ctx, currentY + y, fld, true);
                  if (this.updateCurrentY) {
                    currentY = currentY + reportProcess.c_dblDEFAULTCELL_Y;
                  }

                  if (y_Returned > lastCurrentY) {
                    lastCurrentY = y_Returned;
                  }
                }
                fld.setData("");
              }
            }
              break;
            case ReportObjectType.otCompanyField: {
              //To do
              //  STRING_ARRAY & comprec = pRW -> GetCompanyRecord();
              //  CReportCompanyField * pFld = (CReportCompanyField *)pObj;
              //  int iFieldIndex = pRW -> GetReportCompanyFieldIndex(pFld -> GetFullName());
              //  if (iFieldIndex >= 0 && iFieldIndex < comprec.GetSize()) {
              //    pFld -> SetData(comprec.GetAt(iFieldIndex));
              //    CReportCompanyField selectionFld;
              //    if (pRW -> GetCompanySelectionField(pFld -> GetFullName(), selectionFld)) {
              //      pFld -> SetHandWriting(selectionFld.GetHandWriting());
              //    }

              //    double dblY_Returned = DoFormat(pdc, dblCurrentY + dblY/*pObj->GetY()*/, pFld);
              //    if (dblY_Returned > dblLastCurrentY)
              //      dblLastCurrentY = dblY_Returned;
              //  }
              //  pFld -> SetData(_T(""));
            }
              break;
            case ReportObjectType.otCustomField: {
              if (null != rec) {
                // To do
                //  CReportCustomField * pFld = (CReportCustomField *)pObj;
                //  int iFieldIndex = pRW -> GetReportFieldIndex(pFld -> GetFullName());
                //  if (iFieldIndex >= 0 && iFieldIndex < prec -> GetSize()) {
                //    pFld -> SetData(prec -> GetAt(iFieldIndex));
                //    CReportCustomField selectionFld;
                //    if (pRW -> GetCustomSelectionField(pFld -> GetFullName(), selectionFld)) {
                //      pFld -> SetHandWriting(selectionFld.GetHandWriting());
                //    }

                //    double dblY_Returned = DoFormat(pdc, dblCurrentY + dblY/*pObj->GetY()*/, pFld);
                //    if (dblY_Returned > dblLastCurrentY)
                //      dblLastCurrentY = dblY_Returned;
                //  }
                //  pFld -> SetData(_T(""));
              }
            }
              break;
            case ReportObjectType.otSystemField: {
              let fld: reportSystemField = <reportSystemField>obj;
              let sysdata = reportProcess.sysdata;
              let data: string = "";
              switch (fld.getSystem()) {
                case ReportSystemFieldTypes.sysNone:
                  break;
                case ReportSystemFieldTypes.sysPageNumber:
                  data = sysdata.currentPageNumber.toString();
                  break;
                case ReportSystemFieldTypes.sysRecordCount:
                  data = sysdata.currentRecordNumber.toString();
                  break;
                case ReportSystemFieldTypes.sysDate:
                  data = Iceutility.getDateTextEx(sysdata.dateTime, null, false);
                  break;
                case ReportSystemFieldTypes.sysTime:
                  data = Iceutility.getDateTextEx(sysdata.dateTime, null, true);
                  break;
                case ReportSystemFieldTypes.sysDateTime:
                  data = Iceutility.getDateTextEx(sysdata.dateTime, null, true);
                  break;
              }

              fld.setData(data);
              let y_Returned = this.doFormat(reportProcess, rptTemplate, ctx, currentY + y, fld, true);
              if (y_Returned > lastCurrentY)
                lastCurrentY = y_Returned;

              fld.setData("");
            }
              break;
            case ReportObjectType.otParameterField:
              break;
            case ReportObjectType.otFormulaField: {
              // To do
              //  CReportEvaluator & eval = pDoc -> GetReportEvaluator();
              //  CReportFormulaField * pFld = (CReportFormulaField *)pObj;
              //  int nIndex = pRW -> GetFormulaIndex(pFld -> GetColumnName());
              //  if (nIndex >= 0) {
              //    CReportFormulaField * pMainFormulaField = pRW -> GetFormula(nIndex);
              //    if (pMainFormulaField) {
              //      double val = 0.0;
              //      CString strFormula = pMainFormulaField -> GetFormula();

              //      CString strData;
              //      eval.evaluate(strFormula, strData);

              //      val = atof((const char*)strData.GetString());
              //      strData.Format(_T("%.2lf"), val);

              //      pFld -> SetData(strData);
              //      double dblY_Returned = DoFormat(pdc, dblCurrentY + dblY/*pObj->GetY()*/, pFld);
              //      if (dblY_Returned > dblLastCurrentY)
              //        dblLastCurrentY = dblY_Returned;

              //      pFld -> SetData(_T(""));
              //    }
              //  }
            }
              break;
            case ReportObjectType.otSummationField: {
              let fld: reportSummationField = <reportSummationField>obj;
              // To do
              //     let nSumFldIndex = pRW -> GetSumFieldIndex(pFld -> GetFullName());
              //     if (nSumFldIndex >= 0) {
              //       CReportSummationField * pStoredSumFld = pRW -> GetSumField(nSumFldIndex);
              //       if (pStoredSumFld) {

              //         COleVariant var ;
              //:: VariantInit(&var);

              //         switch (pRW -> GetSectionType(pSection)) {
              //           case CReportWriter:: secReportHeader:
              //case CReportWriter:: secPageHeader:
              //case CReportWriter:: secSortHeader1:
              //case CReportWriter:: secSortHeader2:
              //case CReportWriter:: secSortHeader3:
              //             {
              //               var = pStoredSumFld-> GetHeaderValue();
              //               break;
              //             }
              //           case CReportWriter:: secDetail:
              //             {
              //               var = pStoredSumFld-> GetDetailValue();
              //               break;
              //             }
              //           case CReportWriter:: secSortFooter1:
              //case CReportWriter:: secSortFooter2:
              //case CReportWriter:: secSortFooter3:
              //case CReportWriter:: secPageFooter:
              //case CReportWriter:: secReportFooter:
              //             {
              //               var = pStoredSumFld-> GetFooterValue();
              //               break;
              //             }
              //         }

              //         CString strData;
              //         switch (pStoredSumFld -> GetDataType()) {
              //           case CColumnData:: dtypeNumber:
              //             {
              //               strData.Format(_T("%ld"), V_I4(&var));
              //               break;
              //             }
              //           case CColumnData:: dtypeFloat:
              //             {
              //               strData.Format(_T("%.2lf"), V_R8(&var));
              //               break;
              //             }
              //         }

              //         pFld -> SetData(strData);
              //         double dblY_Returned = DoFormat(pdc, dblCurrentY + dblY/*pObj->GetY()*/, pFld);
              //         if (dblY_Returned > dblLastCurrentY)
              //           dblLastCurrentY = dblY_Returned;

              //         pFld -> SetData(_T(""));
              //       }
              //     }
            }
              break;
            case ReportObjectType.otPicture:
              break;
          }

          //if (i === objs.length - 1) {
          //  this.megaY = currentY;
          //}
        }
      } // each object
    } // each line

    if (lastCurrentY > currentY)
      currentY = lastCurrentY;

    return currentY + reportProcess.c_dblDEFAULTPADDING_Y;
  }

  doFormat(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, y: number, fld: reportField, coordinate: boolean): number {
    let handwritingY = y;
    if (null == fld)
      return -1.0;

    let sysdata = reportProcess.sysdata;
    let rcMargins: IceRect = rptTemplate.getMargins();
    let leftOffset: number = 0.0;
    if (coordinate == false)
      leftOffset = rcMargins.left;

    let rect: IceRect = new IceRect(0, 0, 0, 0);
    rect.left = basereportprocess.inch2Pix(leftOffset + fld.getX(), sysdata.pixelsPerInch, sysdata.scale);
    rect.top = basereportprocess.inch2Pix(y, sysdata.pixelsPerInch, sysdata.scale);
    rect.right = basereportprocess.inch2Pix(leftOffset + fld.getX() + fld.getWidth(), sysdata.pixelsPerInch, sysdata.scale);
    rect.bottom = basereportprocess.inch2Pix(y + fld.getHeight(), sysdata.pixelsPerInch, sysdata.scale);

    // To do
    //pdc -> SetBkMode(TRANSPARENT);
    //To do once Multimedia service is done
    //if (fld.getHandWriting()) {
    //  let grfPages: IcegraffitiPage[] = this.grafittiSvc.deserialize(fld.getData());
    //  if (grfPages && grfPages.length > 0) {
    //    let theLowestPoint: IcePoint = new IcePoint();//this.grafittiSvc.draw(ctx, grfPages, rect, false);
    //    handwritingY += this.pix2Inch(theLowestPoint.y, sysdata.pixelsPerInch, sysdata.scale);
    //    this.doBorder(ctx, fld, rect);
    //    return handwritingY;
    //  }
    //}

    let text = fld.getData();
    // check to see if we're complete
    if (text == null || text.length == 0) {
      this.doBorder(ctx, fld, rect);
      // To do this adjustment causes unwanted spaces between records, investigate to see if needed.
      //y = basereportprocess.pix2Inch(rect.bottom, sysdata.pixelsPerInch, sysdata.scale);
      return y;
    }

    // To do
    switch (fld.getDataType()) {
      case ReportDataTypes.dtNumber:
        {
          // do nothing for now later we will add the format mask
          //long nTextEquivelent = atol(strText);
          //strText.Format(_T("%ld"), nTextEquivelent);
          break;
        }
      case ReportDataTypes.dtDouble:
        {
          // do nothing for now later we will add the format mask
          //double dblTextEquivelent = atof(strText);
          //strText.Format(_T("%lf"), dblTextEquivelent);
          break;
        }
      case ReportDataTypes.dtText:
        break;
      case ReportDataTypes.dtDateTime:
        break;
      case ReportDataTypes.dtBoolean:
        {
          //long nTextEquivelent = atol((const char*)strText.GetString());
          //strText.Format(_T("%s"), nTextEquivelent == TRUE ? _T("Yes") : _T("No"));
          break;
        }
      default:
        break;
    }

    let align = fld.getAlignType();
    let size: IcePoint = new IcePoint(0, 0); // Substitute IcePoint for CSize
    if (fld.getWrap()) {
      // To do
      //  CStringArray arLines;
      //  long nTop = rect.top;
      //  long nGreatestLineLength = 0;
      //  CColumnData:: BreakIntoLines(pdc, strText, * lpLogFont, pFld -> GetWidth(), arLines, nGreatestLineLength);
      //  for (int nLine = 0; nLine < arLines.GetSize(); nLine++ )
      //  {
      //    CString strLine = arLines.GetAt(nLine);
      //    if (nTop > rect.bottom)
      //      break; // don't draw outside of rect.

      //    CPoint ptAlignOffset = GetAlignmentOffset(pdc, dwAlign, CRect(rect.left, nTop, rect.right, rect.bottom), strLine, 2);
      //    pdc -> TextOut(ptAlignOffset.x, ptAlignOffset.y/*rect.left, nTop*/, strLine);
      //    size = pdc -> GetTextExtent(strLine);
      //    nTop += size.cy;
      //    nTop += (size.cy / 2);
      //  }
      //  size.cy = nTop;
      //  //size.cy = pdc->DrawText(strText, &rect, DT_LEFT | DT_EXTERNALLEADING);			

      // To do we will need update the bottom calc
      //y += repSvc.pix2Inch(rect.bottom/*size.y*/, sysdata.pixelsPerInch, sysdata.scale);
      //this.doBorder(ctx, fld, rect);
    }
    else {
      let chunks = this.splitStringIntoChunks(text, 100);
      let fontInches = Iceutility.toLong(fld.getFontSize()) / reportProcess.c_dblFontPointsPerInch;
      let fontPixels = basereportprocess.inch2Pix(fontInches, sysdata.pixelsPerInch, sysdata.scale);
      let fontToUse = [fld.getFontItalic() ? "Italic" : "", fld.getFontBold() ? "Bold" : "", fontPixels.toString() + "px", fld.getFontName()];
      let ptAlignOffset = this.getAlignmentOffset(ctx, align, rect, text, fontToUse.join(' '), Iceutility.toLong(fld.getFontSize()), 2);

      for (let chunk of chunks) {
        let saveFont = ctx.font;
        ctx.font = fontToUse.join(' ');//'12px sans-serif'; // This should come from fld
        ctx.strokeStyle = "black";
        ctx.fillText(chunk, ptAlignOffset.x, ptAlignOffset.y/*rect.left, rect.top*/);
        ctx.font = saveFont;
        size = ptAlignOffset;
        this.doBorder(ctx, fld, rect);
        ptAlignOffset.y = ptAlignOffset.y + 20;
      }

      this.updateCurrentY = chunks.length > 1;
    }

    return y;
  }

  splitStringIntoChunks(str, chunkSize) {
    const regex = new RegExp(`.{1,${chunkSize}}`, 'g');
    return str.match(regex);
  }

  doFormatData(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, y: number, fld: reportDataField, coordinate: boolean): number {
    let bcType: ReportBarCodeType = fld.getBarCodeType();
    if (bcType == ReportBarCodeType.TypeNone) {
      y = this.doFormat(reportProcess, rptTemplate, ctx, y, fld, coordinate);
    }
    else {
      let barcodeY: number = y;
      let objectY: number = this.doFormat(reportProcess, rptTemplate, ctx, y, fld, true);

      let strFileName = "", strBitmapName = "", data = fld.getData();
      if (data == null || data.length == 0) return objectY;
      ////////////
      // To do
      //   if (CColumnData:: CreateTemporaryFile("c:\\temp", strData, strFileName))
      //   {
      //     static CString barcodePath = "";
      //     static CString path = CBaseLog:: GetAppPath() + "RW.ini";

      //     if (barcodePath.IsEmpty()) {
      //       const size_t bufSize = 1024;
      //       TCHAR buffer[bufSize + 1];
      //       memset(buffer, 0, bufSize + 1);
      //       int ret = GetPrivateProfileString("CONFIG", "BarcodeApp", "", buffer, bufSize, path);
      //       if (!ret) {
      //         barcodePath = ".\\RWBarcode.exe";
      //       }
      //       else {
      //         barcodePath = buffer;
      //       }
      //     }

      //     strBitmapName = strFileName + ".bmp";
      //     CString strCmdLine; strCmdLine.Format("-in \"%s\" -properties \"type=%s text=%ld\" -out \"%s\"", strFileName, CReportDataField:: GetBarCodeTypeCommand(bcType), pFld -> GetBarCodeShowText(), strBitmapName);

      //     #if true
      //     if (FALSE == LaunchProcess(barcodePath, strCmdLine)) {
      //       DWORD dw = GetLastError();
      //       AfxMessageBox(std:: string("Failed to Launch Barcode").c_str(), MB_OK);
      //     }
      //     #else
      //     std:: string props = std:: string("type=") + std:: string(CReportDataField:: GetBarCodeTypeCommand(bcType).GetString()) + std:: string(" text=") + std:: string(pFld -> GetBarCodeShowText() ? "1" : "0");
      //     bar.NewBarCode(m_hWnd, std:: string(strData.GetString()), props, std:: string(strFileName + ".bmp"));
      //     #endif
      //   }

      //   CBitmap * pBmp = pFld -> GetBarCodeBitmap();
      //   pBmp -> DeleteObject();

      //   if (pdc -> m_hDC == NULL) {
      //     TRACE("Error condition.\n");
      //   }

      //   #if true
      //   HBITMAP hBitmap = (HBITMAP):: LoadImage(NULL, strBitmapName, IMAGE_BITMAP, 0, 0, LR_LOADFROMFILE);
      //   #else
      //   HBITMAP hBitmap = NULL;
      //   #endif

      //   if (pdc -> m_hDC == NULL) {
      //     TRACE("Error condition.\n");
      //   }

      //   //if (pBmp->LoadBitmap(CReportDataField::GetBarCodeTypeText(pFld->GetBarCodeType()))) {
      //   if (hBitmap != NULL) {
      //     pBmp -> Attach(hBitmap);

      //     // To do: Replace this code with DoImage(...)
      //     CReportWriter * pRW = pDoc -> GetReportWriter();
      //     if (NULL == pRW)
      //       return -1.0;

      //     CRect & rcMargins = pRW -> GetMargins();
      //     double dblLeftOffset = 0.0;
      //     if (bCoordinate == FALSE)
      //       dblLeftOffset = ((double)rcMargins.left / (double)c_lnUnRealizedPixelPerInch);

      //     CRect rect;
      //     rect.left = CColumnData:: Inch2Pix(dblLeftOffset + pFld -> GetX(), pdc -> GetDeviceCaps(LOGPIXELSX), c_dblUnRealizedScale);
      //     rect.top = CColumnData:: Inch2Pix(dblY, pdc -> GetDeviceCaps(LOGPIXELSY), c_dblUnRealizedScale);
      //     rect.right = CColumnData:: Inch2Pix(dblLeftOffset + pFld -> GetX() + pFld -> GetWidth(), pdc -> GetDeviceCaps(LOGPIXELSX), c_dblUnRealizedScale);
      //     rect.bottom = CColumnData:: Inch2Pix(dblY + pFld -> GetHeight(), pdc -> GetDeviceCaps(LOGPIXELSY), c_dblUnRealizedScale);

      //     if (bcType != CReportDataField:: Standard1D_Code128 && bcType != CReportDataField:: Standard1D_Code39 && bcType != CReportDataField:: Standard1D_Code93)
      //     rect.DeflateRect(15, 15, 15, 15);

      //     if (pdc -> m_hDC == NULL) {
      //       TRACE("Error condition.\n");
      //     }

      //     CDC memDC;
      //     if (memDC.CreateCompatibleDC(pdc)) {
      //       DIBSECTION dibsection;
      //       pBmp -> GetObject(sizeof(DIBSECTION), & dibsection);

      //       memDC.SelectObject(pBmp);

      //       if (pdc -> m_hDC == NULL) {
      //         TRACE("Error condition.\n");
      //       }

      //       int OldBackMode = memDC.SetBkMode(TRANSPARENT);
      //       if (pFld -> GetScaleToFit()) {
      //         pdc -> StretchBlt(
      //           rect.left, rect.top, rect.Width(), rect.Height(), //rect.Height(), do the full height
      //			      & memDC, 0, 0, dibsection.dsBm.bmWidth, dibsection.dsBm.bmHeight, SRCCOPY);
      //       }
      //       //else if (dibsection.dsBm.bmHeight > rect.Height()
      //       //	&& dibsection.dsBm.bmWidth > rect.Width()) // no tolerance here because we know we must scale down
      //       //													// and the code above filtered out the over tolerance data
      //       //{
      //       //	pdc->StretchBlt(
      //       //		rect.left, rect.top, rect.Width(), rect.Height(), //rect.Height(), do the full height
      //       //		&memDC, 0, 0, dibsection.dsBm.bmWidth, dibsection.dsBm.bmHeight, SRCCOPY);
      //       //}
      //       else {
      //         pdc -> BitBlt(rect.left, rect.top,
      //           dibsection.dsBm.bmWidth,
      //           dibsection.dsBm.bmHeight,
      //			      & memDC, 0, 0, SRCCOPY);
      //       }
      //       memDC.SetBkMode(OldBackMode);
      //       memDC.DeleteDC();

      //       barcodeY += pFld -> GetHeight(); // Let's use the barcode height instead of the dibsection.dsBm.bmHeight
      //     }
      //   }

      //   CFile:: Remove(strFileName);
      //   CFile:: Remove(strBitmapName);

      //   dblY = max(objectY, barcodeY);
      //   dblY = max(dblY, pFld -> GetHeight());
    }
    return y;
  }

  doFormatObject(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, y: number, obj: reportObject, setBackColor: boolean): number {
    if (null == obj)
      return -1.0;

    // To do
    //pdc -> SetBkMode(TRANSPARENT);

    let rcMargins: IceRect = rptTemplate.getMargins();
    let leftOffset: number = rcMargins.left;

    let sysdata = reportProcess.sysdata;
    let rect: IceRect = new IceRect();
    rect.left = basereportprocess.inch2Pix(leftOffset + obj.getX(), sysdata.pixelsPerInch, sysdata.scale);
    rect.top = basereportprocess.inch2Pix(y, sysdata.pixelsPerInch, sysdata.scale);
    rect.right = basereportprocess.inch2Pix(leftOffset + obj.getX() + obj.getWidth(), sysdata.pixelsPerInch, sysdata.scale);
    rect.bottom = basereportprocess.inch2Pix(y + obj.getHeight(), sysdata.pixelsPerInch, sysdata.scale);

    // background color
    if (setBackColor) {
      let saveFillStyle = ctx.fillStyle;
      // To do
      //ctx.fillStyle = "green"; convert to RGB to HEX
      /*
      function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
      }

      function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
      }
      */
      ctx.fillRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top);
      ctx.fillStyle = saveFillStyle;
    }

    /*
    // To do base64 image
    double imageY = -1.0;
    CString imageData = pObj -> GetImageData();
    if (!imageData.IsEmpty()) {
      CByteArray bytes;
      if (CColumnData:: Base64Decode("Base64", imageData, bytes))
      {
        CBitmap * pBmp = pObj -> GetImage();
        pBmp -> DeleteObject();

        CString strFileName;
        if (CColumnData:: GetTemporaryFileName("c:\\temp", strFileName))
        {
          strFileName += ".bmp";
          if (CColumnData:: WriteFile(strFileName, bytes))
          {
            HBITMAP phBitmap = (HBITMAP)LoadImage(NULL, strFileName, IMAGE_BITMAP, 0, 0,
              LR_CREATEDIBSECTION | LR_DEFAULTSIZE | LR_LOADFROMFILE);
            if (phBitmap != NULL) {
              pBmp -> Attach(phBitmap);

              imageY = DoImage(pdc, dblY, pObj, pBmp, FALSE);
              CFile:: Remove(strFileName);
            }
          }
        }
      }
    }
    */
    this.doBorder(ctx, obj, rect);
    y += obj.getHeight();
    return y;
  }

  doBorder(ctx: CanvasRenderingContext2D, obj: reportObject, rect: IceRect): void {
    if (obj == null)
      return;

    // Border stuff
    let borders: IceRect = obj.getBorders();
    let borderStyle: Report_Border_Style = obj.getBorderStyle();
    let borderColor: string = obj.getBackColor();
    // To do set ctx
    this.doRect(ctx, borders, rect);
    // To do restore ctx
  }

  doRect(ctx: CanvasRenderingContext2D, borders: IceRect, rect: IceRect): void {
    rect.deflateRect(0, 5, 0, 0);
    rect.inflateRect(0, 0, 0, 5);
    let borderlineoffset = 0;
    ctx.beginPath();
    if (borders.left == 1) {
      ctx.moveTo(rect.left + borderlineoffset, rect.top + borderlineoffset);
      ctx.lineTo(rect.left + borderlineoffset, rect.bottom + borderlineoffset);
    }

    if (borders.right == 1) {
      ctx.moveTo(rect.right + borderlineoffset, rect.top + borderlineoffset);
      ctx.lineTo(rect.right + borderlineoffset, rect.bottom + borderlineoffset);
    }

    if (borders.top == 1) {
      ctx.moveTo(rect.left + borderlineoffset, rect.top + borderlineoffset);
      ctx.lineTo(rect.right + borderlineoffset, rect.top + borderlineoffset);
    }

    if (borders.bottom == 1) {
      this.bottomBorderCount++;
      if (this.bottomBorderCount == 3) {
        rect.bottom = rect.bottom - (this.longTextCount * 26.8);
      }
      ctx.moveTo(rect.left + borderlineoffset, rect.bottom + borderlineoffset);
      ctx.lineTo(rect.right + borderlineoffset, rect.bottom + borderlineoffset);
    }

    ctx.closePath();
    ctx.stroke();
    rect.inflateRect(0, 5, 0, 0);
    rect.deflateRect(0, 0, 0, 5);
  }

  printReportHeader(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secReportHeader);
    if (section && section.objects.length > 0) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secReportHeader, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return sectionStart;
  }

  printPageHeader(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secPageHeader);
    if (section && section.objects.length > 0) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secPageHeader, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return sectionStart;
  }

  printSortHeader1(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader1);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortHeader1, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printSortHeader2(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader2);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortHeader2, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printSortHeader3(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortHeader3);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortHeader3, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printDetail(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secDetail);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secDetail, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printPageFooter(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, estimatedFooterHeigt: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secPageFooter);
    if (section && section.objects.length > 0) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secPageFooter, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      let sysdata = reportProcess.sysdata;
      sectionStart = basereportprocess.pix2Inch(sysdata.pageLimitY, sysdata.pixelsPerInch, sysdata.scale) - estimatedFooterHeigt;
      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return sectionStart;
  }

  printSortFooter1(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter1);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortFooter1, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printSortFooter2(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter2);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortFooter2, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printSortFooter3(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secSortFooter3);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secSortFooter3, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printReportFooter(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sectionStart: number, rec: any[]): number {
    // insert items into report
    let section: reportSection = reportProcess.getSectionByType(ReportSectionTypes.secReportFooter);
    if (section) {
      // calc summations
      //UpdateSumFields(CReportWriter:: secReportFooter, prec);

      // skip the display
      if (false == section.getShow())
        return sectionStart;

      sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, section, rec);
      return sectionStart;
    }

    return -1.0;
  }

  printSection(reportProcess: basereportprocess, rptTemplate: report, ctx: CanvasRenderingContext2D, sec: reportSection, sectionStart: number, rec: any[]) {
    if (sec == null) return -1.0;

    // insert items into report
    // calc summations
    //UpdateSumFields(sortfield, prec);

    // skip the display
    if (false == sec.getShow())
      return sectionStart;

    sectionStart = this.doSection(reportProcess, rptTemplate, ctx, sectionStart, sec, rec);
    sec.setPrinted(true);
    return sectionStart;
  }
}
